// src/Pages/EventInstructions.js
import React from "react";
import { Link } from "react-router-dom";
import "./FAQ.css";
import registerGatheringImg from "../../assets/register-gathering.png";
import createGatheringImg from "../../assets/create-gathering.png";
import gatheringDashboardImg from "../../assets/gathering-dashboard.png";


export default function GatheringInstructions() {
  return (
    <div className="faq-container">
      <h2 className="faq-heading">Gathering Host Instructions</h2>
      <p className="faq-text">How to set up and run your event with itiniri:</p>
      <ol className="faq-steps">
        <li className="faq-step-item">
          Log in at itiniri.app/auth and go to Dashboard
        </li>
        <li className="faq-step-item">
          Click <strong>Register a New Event</strong>.
        </li>
        <img
          src={registerGatheringImg}
          alt="Descriptive text"
          className="faq-image"
        />
        <li className="faq-step-item">
          Enter your basic Event Details and click <strong>Create Gathering</strong>.
        </li>
        <img
        style={{width:"75%"}}
          src={createGatheringImg}
          alt="Descriptive text"
          className="faq-image"
        />
        <li className="faq-step-item">
          Use the tabs inside your Gathering Dashboard to add your logo and map
          images, your schedule, your team members and much more. Instructions
          are provided in those tabs as well.
        </li>
        <img
          src={gatheringDashboardImg}
          alt="Descriptive text"
          className="faq-image"
        />

        <li className="faq-step-item">
          Make sure you click <strong>Save Changes</strong> after making changes
          so you don't lose your progress.
        </li>
        <li className="faq-step-item">
          Share your <strong>Gathering Reference ID</strong> with the Vendors,
          Artists and other Event Participants so they can link to your Event.
        </li>
        <li className="faq-step-item">
          When you're ready to go live on the app, review everything and click{" "}
          <strong>Publish</strong>. Submit your payment through our online
          terminal and your Event will be visible to your attendees. Note: You
          can choose to hide your event after payment as well.
        </li>
        <li className="faq-step-item">
          Share your shortcode with your attendees so they can view your Event
          in the app.
        </li>
      </ol>
      <Link to="/faq" className="faq-back-link">
        ← Back to FAQ
      </Link>
    </div>
  );
}
